import { Service } from '@angular/core';

@Service()
export class CobrowsingService {
  showStartButton = false;

  startCobrowsing() {
    // @ts-ignore
    window.CV.universal.open();
  }

  initializeCobrowsing(doc: Document, widgetKey: string) {
    const s = doc.createElement('script');

    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://cdn.chatvisor.com/cdn/js/' + widgetKey + '.js';
    const head = doc.getElementsByTagName('head')[0];
    head.appendChild(s);

    const interval = setInterval(() => {
      // @ts-ignore
      if (window.CV?.cobrowse?.addCobrowsingStartedListener) {
        clearInterval(interval);
        // @ts-ignore
        window.CV.cobrowse.addCobrowsingStartedListener(() => {
          this.showStartButton = false;
        });
        // @ts-ignore
        window.CV.cobrowse.addCobrowsingStoppedListener(() => {
          this.showStartButton = true;
        });
        this.showStartButton = true;
        console.log('Cobrowsing initialisiert');
      }
    }, 250);
  }
}
